import styled, { css } from 'styled-components';
export const Container = styled.div `
  position: relative;
  overflow: hidden;

  display: flex;

  align-items: ${({ align }) => align};
  justify-content: center;

  padding: 12px;
  border-radius: var(--radius-brand);

  width: 100%;
  height: 100%;
`;
export const IframeContainer = styled.div `
  position: relative;

  display: flex;

  align-items: center;
  justify-content: center;

  border-radius: var(--radius-brand);

  width: 100%;
  height: 100%;
`;
export const SkeletonWrapper = styled.div `
  width: 100%;
  min-height: 244px;
  height: 100%;
`;
export const Iframe = styled.iframe `
  position: absolute;

  opacity: 0;
  pointer-events: none;

  border: none;
  border-radius: var(--radius-brand);

  ${({ loaded }) => loaded &&
    css `
      --scale: min(
        calc(var(--containerHeight) / var(--previewHeight)),
        calc(var(--containerWidth) / var(--previewWidth))
      );

      position: absolute;
      top: 50%;
      left: 50%;

      display: inline-block;

      opacity: 1;
      overflow: hidden;
      transform-origin: 0 0;
      transform: scale(var(--scale)) translate(-50%, -50%);

      height: calc(var(--previewHeight) * 0.0625rem);
      width: calc(var(--previewWidth) * 0.0625rem);
    `}
`;
export const Overlay = styled.div `
  position: absolute;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: calc(100% + 12px);

  cursor: pointer;

  &:hover {
    border-radius: var(--radius-brand);
    border: 2px solid var(--border-active);
  }
`;
